import { cn } from '@/lib/utils'

/** Düşük maliyetli iskelet — NewsCard grid ile aynı oranlar */
const bar = 'animate-pulse rounded-md bg-gray-200 dark:bg-slate-700'

export interface NewsCardSkeletonBodyProps {
  showTagStrip?: boolean
  showDate?: boolean
}

export function NewsCardSkeletonBody({
  showTagStrip = true,
  showDate = true,
}: NewsCardSkeletonBodyProps) {
  return (
    <>
      <div className="relative aspect-video w-full overflow-hidden bg-gray-100 dark:bg-slate-700">
        <div className="absolute inset-0 animate-pulse bg-gray-200 dark:bg-slate-700" />
        {showTagStrip && (
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/10 to-transparent p-2.5 sm:p-3">
            <div className={cn(bar, 'h-5 w-20')} />
          </div>
        )}
      </div>
      <div className="space-y-2 p-2.5 sm:p-3 lg:p-3.5">
        <div className={cn(bar, 'h-4 w-full')} />
        <div className={cn(bar, 'h-4 w-[88%]')} />
        {showDate ? <div className={cn(bar, 'h-3 w-24')} /> : null}
      </div>
    </>
  )
}

export interface NewsCardSkeletonProps extends NewsCardSkeletonBodyProps {
  className?: string
  plain?: boolean
}

export function NewsCardSkeleton({
  showTagStrip = true,
  showDate = true,
  className,
  plain = false,
}: NewsCardSkeletonProps) {
  return (
    <article
      className={cn(
        'news-card-surface min-w-0 overflow-hidden rounded-[5px]',
        plain
          ? 'border-0 bg-transparent dark:bg-transparent'
          : 'border border-gray-100 bg-white dark:border-slate-800 dark:bg-slate-800',
        className,
      )}
      aria-busy="true"
    >
      <NewsCardSkeletonBody showTagStrip={showTagStrip} showDate={showDate} />
    </article>
  )
}
